module.exports = __webpack_public_path__ + "static/bett1ACES-1440x730-v2-c30a464ad074a6968dcb1822e916fb8d.mp4";